import React, { Component } from 'react';
import { Menu, Segment } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'
import ReactHtmlParser from 'react-html-parser';

export default class Info extends Component {

  constructor(props){
      super(props)
      this.fetcher = this.fetcher.bind(this)
      this.state={
        htm:null,
        isFetching:true,
        activeItem: '6'
      }
  }

// const Problem = props => {



handleItemClick = (e, { name }) => {

  this.setState({ activeItem: name },
    ()=> {this.fetcher(this.state.activeItem)}
  )


}


fetcher(id){

  fetch('http://devb240.tula.ru:8080/api/ocnitdate',
    {
  method: 'POST',
  headers: new Headers({
           'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
           'Access-Control-Allow-Origin': '*',
  }),
  body: "id="+id
    }    )
    .then((response)=>response.json())
      .then((data)=>{
          // this.setState ({htm:data[0].htm})
          this.setState ({

            htm:ReactHtmlParser(data[0].htm),
            isFetching:false

          })

      })

}

componentDidMount() {

    this.fetcher(this.state.activeItem)

}


render(){
  const { activeItem, htm, isFetching } = this.state


  return (


      <div>

        <Menu attached='top' tabular>
          <Menu.Item name='6' active={activeItem === '6'} onClick={this.handleItemClick}>Приказ об организации ОЦНИТ</Menu.Item>
          <Menu.Item name='8' active={activeItem === '8'} onClick={this.handleItemClick}>Положение об ОЦНИТ</Menu.Item>

        </Menu>
       <Segment attached='bottom'>{activeItem}

         {isFetching ? 'Загружаем': htm}

       </Segment>

      </div>
  )
}
}

// export default Problem
